import { config } from '@grafana/runtime';

const predefinedClouds = [
  {
    name: "AzureCloud",
    displayName: "Azure"
  },
  {
    name: "AzureChinaCloud",
    displayName: "Azure China"
  },
  {
    name: "AzureUSGovernment",
    displayName: "Azure US Government"
  }
];
function getAzureClouds() {
  const settingsEx = config.azure;
  if (Array.isArray(settingsEx.clouds) && settingsEx.clouds.length > 0) {
    return settingsEx.clouds;
  }
  return predefinedClouds;
}

export { getAzureClouds };
//# sourceMappingURL=clouds.js.map
